export default __webpack_public_path__ + "static/media/03.258f901f.jpg";